import { Button, Checkbox, Grid } from "@mui/material";
import { NoContentSet } from "./NoContentSet";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { useRecordContext } from "react-admin";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function AddOns({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const data = record?.data?.basic?.addons;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;
  const subType = record?.data?.basic?.subType;
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        sAllowLowerRate: data?.sAllowLowerRate || "",
        sAllowExtraPayments: data?.sAllowExtraPayments || "",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = "addons";
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  let showAddOns = false;
  if (
    productModulesGroup?.includes("product-addons") ||
    subType === "employee"
  ) {
    showAddOns = true;
  }
  return (
    <SectionStyled id="section_calculation">
      <SectionTitle title="Add-Ons - Additional Features of This Product" />
      {showAddOns ? (
        <>
          <Box
            sx={{
              padding: "10px",
              height: "calc(100vh - 255px)",
              overflowY: "auto",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} container spacing={1}>
                <Grid item xs={12}>
                  <Controller
                    name="sAllowLowerRate"
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        size="small"
                        color="primary"
                        checked={field.value === "YES"}
                        onChange={(e) => {
                          field.onChange(e.target.checked ? "YES" : "NO");
                        }}
                      />
                    )}
                  />
                  Allow borrowers to choose ACH payment method linked to lower
                  interest rate
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="sAllowExtraPayments"
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        size="small"
                        color="primary"
                        checked={field.value === "YES"}
                        onChange={(e) => {
                          field.onChange(e.target.checked ? "YES" : "NO");
                        }}
                      />
                    )}
                  />
                  Allow borrowers to make extra payments along with scheduled
                  loan payments
                </Grid>
              </Grid>
            </Grid>
          </Box>
          {/* Save Button */}
          <CustomProductActionBottom>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveClick}
              disabled={!isDirty}
              sx={{ width: "120px", mt: 1 }}
            >
              Save
            </Button>
          </CustomProductActionBottom>
        </>
      ) : (
        <NoContentSet />
      )}
    </SectionStyled>
  );
}
